import { List } from 'components/ui';
import ListItem from 'components/session_info/index/list_item';
import ListHeader from 'components/session_info/index/list_header';

const Index = ({ sessionInfos, onRemove }) => {
  return (
    <List>
      <ListHeader />
      {sessionInfos.map((sessionInfo) => (
        <ListItem key={sessionInfo.id} sessionInfo={sessionInfo} onRemove={onRemove} />
      ))}
    </List>
  );
};

export default Index;
